//PDF预览

import jsPreviewDocx from "@js-preview/docx";
import jsPreviewPdf from "@js-preview/pdf";
import { useEffect } from 'react';
import { FileEntity } from "./Entity";
import { URL_file_downloadFile } from "./Utils/UrlUtils";

export default (props: any) => {

  // const [fileEntity,setFileEntity] = useState<FileEntity>()
  let f = sessionStorage.getItem('f')
  console.log(f)
  let fileEntity: FileEntity
  if (f) {
    fileEntity = JSON.parse(f)
    document.title = fileEntity.name ? fileEntity.name : '文件预览'
    // setFileEntity(fileEntity)
  } else {
    document.title = ''
  }
  useEffect(() => {
    getPreviewUrl(fileEntity)
  }, []);

  const getPreviewUrl = async (f?: FileEntity) => {
    if (!f) return
    const token = sessionStorage.getItem('token')
    // let h = new Headers({})
    // if(!props.noToken) h.set('Authorization','Xyxyzka ' + token) //带token
    if (f.fileSuffix === '.docx' || f.fileSuffix === '.doc') {
      // console.log('.docx 预览开始')
      var docxView: any = document.getElementById('word-view')
      var myDocxPreviewer = jsPreviewDocx.init(docxView)
      myDocxPreviewer.setRequestOptions({
        method: 'GET', // 请求类型为 GET
        headers: { // 设置 header
          'Authorization': 'Xyxyzka ' + token // Authorization 字段包含身份验证令牌
        }
      })
      await myDocxPreviewer?.preview(URL_file_downloadFile + '?id=' + f.id)
        .then((res: any) => {
          console.log('预览完成');
        })
        .catch((e: any) => {
          console.log('预览失败', e);
        });
    } else if (f.fileSuffix === '.pdf') {
      var pdfView: any = document.getElementById('pdf-view')
      var myPdfPreviewer = jsPreviewPdf.init(pdfView)

      let url = URL_file_downloadFile + '?id=' + f.id
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      //设置请求头参数的方式,如果没有可忽略此行代码
      xhr.setRequestHeader("Authorization", `Xyxyzka ${token}`)
      //设置响应类型为 blob   xhr.open必须为 异步
      xhr.responseType = 'blob';
      console.log(f.fileSuffix)
      //关键部分
      xhr.onload = function (e) {
        //如果请求执行成功
        if (this.status == 200) {
          let blob = this.response;
          myPdfPreviewer?.preview(blob)
            .then((res: any) => {
              console.log('预览完成');
            })
            .catch((e: any) => {
              // debugger
              console.log('预览失败', e);
            });
        }
      }
      xhr.send()
    }
  }

  return (<>
    <div id="pdf-view" style={{ width: '100%', height: '100%' }}></div>
    <div id="word-view" style={{ width: '100%', height: '100%' }}></div>
  </>
  )
}
